import {
  CollabEventPresenceData,
  CollabParticipant,
} from '@livekatsomo/models';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { findCursors } from './findCursors';

/**
 * Updates the participants map and decoration set based on the given presence data.
 * Removes cursors for users that left and adds new participants to the map.
 *
 * @param presenceData - The presence data containing information about joined and left participants.
 * @param participants - The map of participants to update.
 * @param decorationSet - The decoration set to update with cursor decorations.
 * @param remove - The array of decorations to remove.
 */
export function updateParticipants(
  presenceData: CollabEventPresenceData,
  participants: Map<string, CollabParticipant>,
  decorationSet: DecorationSet,
  remove: Decoration[],
) {
  // Extract joined and left participants from presence data
  const {
    joined = [] as CollabParticipant[],
    left = [] as { clientID: string }[],
  } = presenceData;

  left.forEach((i) => {
    // Remove participant from map
    participants.delete(i.clientID);
    // Remove cursors for users that left
    const cursors = findCursors(i.clientID, decorationSet);
    if (cursors) {
      remove.push(...cursors);
    }
  });

  // Add new participants to map
  joined.forEach((i) => participants.set(i.clientID, i));
}
